const Comparability = [
  { value: 1, label: "Inferior" },
  { value: 2, label: "Comparable" },
  { value: 3, label: "Superior" },
];

export default Comparability;
